import { useTranslation } from 'react-i18next'
import { KebabCase } from 'type-fest'

import { SectionTab } from 'components/Tabs'
import { Workspace } from 'features/workspace'
import { MultiAnchorForm } from './Sections/MultianchorSection/Form'

export type RichPlacementsUrlParams = Partial<{
  section: SectionRouteParam
  workspaceId: Workspace['id']
}>

export type SectionRouteParam = KebabCase<
  'multianchor' | 'rich-placement-1' | 'rich-placement-2' | 'rich-placement-3'
>

export const useSectionTabs = (): SectionTab<SectionRouteParam>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.sections',
  })

  return [
    {
      element: 'multianchor',
      label: t('multianchor'),
      page: <MultiAnchorForm />,
    },
  ]
}
